import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const plans = [
    {
        name: 'Essential',
        plan: 'essential',
        badge: 'Standard',
        monthlyPrice: 80,
        description: 'Perfect for small teams and startups.',
        features: ['20 Projects', '100k Characters/mo', '1 App Integration', 'Email Support'],
        highlight: false,
        themeBorder: 'linear-gradient(135deg, #d0f0fd 0%, #a0d9ff 100%)',
        themeColor: '#1976d2',
        hoverColor: '#115293',
        ctaName: 'Get Started'
    },
    {
        name: 'Growth',
        plan: 'growth',
        badge: 'Popular',
        monthlyPrice: 250,
        description: 'For growing companies with global reach.',
        features: ['200 Projects', '1M Characters/mo', '5 App Integrations', 'Priority Support'],
        highlight: true,
        themeBorder: 'linear-gradient(135deg, #e0ffe1 0%, #b3ffb5 100%)',
        themeColor: '#2e7d32',
        hoverColor: '#1b5e20',
        ctaName: 'Upgrade Now'
    },
    {
        name: 'Scale',
        plan: 'scale',
        badge: 'Advanced',
        monthlyPrice: 500,
        description: 'Advanced features for large scale operations.',
        features: ['Unlimited Projects', 'Unlimited Characters', 'Unlimited Apps', 'Dedicated Support'],
        highlight: false,
        themeBorder: 'linear-gradient(135deg, #f3e1ff 0%, #dab6ff 100%)',
        themeColor: '#9c27b0',
        hoverColor: '#7b1fa2',
        ctaName: 'Contact Sales'
    },
];

const PricingPage = () => {
    const [isYearly, setIsYearly] = useState(false);

    const sliderSettings = {
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    };

    return (
        <>
            <section
                id="pricing-2"
                className="bg-snow pb-60 inner-page-hero pricing-section division"
            >
                <div className="container">
                    {/* SECTION TITLE */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-8">
                            <div className="section-title title-01 mb-80 text-center">
                                <h2 className="h2-md" style={{ fontWeight: 600, color: '#1B1B1B' }}>Choose Your Plan</h2>
                                <p className="p-xl" style={{ color: '#6C757D' }}>Choose the right program for your business</p>
                            </div>
                        </div>
                    </div>

                    {/* Monthly / Yearly Toggle */}
                    <div className="row justify-content-center" style={{ marginBottom: '80px' }}>
                        <div className="col-auto">
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#FFFFFF',
                                borderRadius: '30px',
                                padding: '5px',
                                boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.05)',
                            }}>
                                <button
                                    onClick={() => setIsYearly(false)}
                                    style={{
                                        border: 'none',
                                        backgroundColor: !isYearly ? '#1B1B1B' : 'transparent',
                                        color: !isYearly ? '#FFFFFF' : '#6C757D',
                                        borderRadius: '25px',
                                        padding: '8px 24px',
                                        fontWeight: 600,
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Monthly
                                </button>
                                <button
                                    onClick={() => setIsYearly(true)}
                                    style={{
                                        border: 'none',
                                        backgroundColor: isYearly ? '#1B1B1B' : 'transparent',
                                        color: isYearly ? '#FFFFFF' : '#6C757D',
                                        borderRadius: '25px',
                                        padding: '8px 24px',
                                        fontWeight: 600,
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Yearly
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* PRICING TABLES */}
                    <div className="pricing-2-row pc-25">
                        <div className="row justify-content-center" style={{ gap: '20px' }}>
                            {plans.map((plan) => {
                                const price = isYearly ? Math.floor(plan.monthlyPrice * 0.9 * 12) : plan.monthlyPrice;
                                const period = isYearly ? '/ Year' : '/ Month';

                                return (
                                    <div className="col-lg-4" key={plan.name} style={{ maxWidth: '380px' }}>
                                        <div
                                            className="pricing-2-table bg-white mb-40 wow fadeInUp"
                                            style={{
                                                borderRadius: '15px',
                                                padding: '40px 30px',
                                                boxShadow: plan.highlight ? '0px 10px 40px rgba(0, 0, 0, 0.08)' : '0px 4px 20px rgba(0, 0, 0, 0.04)',
                                                position: 'relative',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                height: '100%',
                                                border: 'none'
                                            }}
                                        >
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                height: '6px',
                                                background: plan.themeBorder,
                                                borderTopLeftRadius: '15px',
                                                borderTopRightRadius: '15px',
                                                zIndex: 0
                                            }} />

                                            <div className="pricing-plan text-center" style={{ zIndex: 1, paddingTop: '10px' }}>
                                                {plan.highlight && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '-45px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        backgroundColor: plan.themeColor,
                                                        color: '#FFFFFF',
                                                        padding: '4px 15px',
                                                        borderRadius: '20px',
                                                        fontSize: '12px',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                        zIndex: 2
                                                    }}>
                                                        Most Popular
                                                    </div>
                                                )}

                                                <h5 style={{ fontWeight: 600, color: '#1B1B1B', marginBottom: '20px' }}>{plan.name}</h5>

                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', marginBottom: '10px' }}>
                                                    <sup style={{ fontSize: '24px', fontWeight: 600, color: plan.themeColor, top: '-15px', position: 'relative' }}>£</sup>
                                                    <span style={{ fontSize: '48px', fontWeight: 700, color: plan.themeColor }}>{price}</span>
                                                    <span style={{ fontSize: '14px', color: '#6C757D', marginLeft: '5px' }}>{period}</span>
                                                </div>

                                                <p style={{ color: '#6C757D', fontSize: '14px', marginBottom: '15px' }}>{plan.description}</p>

                                                <Link
                                                    to={`/register?plan=${plan.plan}`}
                                                    style={{
                                                        background: 'transparent',
                                                        border: `1px solid ${plan.themeColor}`,
                                                        borderRadius: '4px',
                                                        color: plan.themeColor,
                                                        padding: '6px 24px',
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                        cursor: 'pointer',
                                                        marginBottom: '24px',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block',
                                                        textDecoration: 'none'
                                                    }}
                                                >
                                                    Try for free
                                                </Link>
                                            </div>

                                            <div style={{ height: '1px', backgroundColor: '#E9ECEF', width: '100%', marginBottom: '25px', opacity: 0.5 }} />

                                            <ul className="features mb-5" style={{ listStyle: 'none', padding: 0, flexGrow: 1 }}>
                                                {plan.features.map((feature, i) => (
                                                    <li key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                        <svg
                                                            width="16"
                                                            height="16"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke={plan.themeColor}
                                                            strokeWidth="3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            style={{ marginRight: '10px', minWidth: '16px' }}
                                                        >
                                                            <polyline points="20 6 9 17 4 12"></polyline>
                                                        </svg>
                                                        <span style={{ color: '#495057', fontSize: '14px' }}>{feature}</span>
                                                    </li>
                                                ))}
                                            </ul>

                                            <div className="text-center mt-auto">
                                                <Link
                                                    to={plan.plan === 'scale' ? '/contact' : `/register?plan=${plan.plan}`}
                                                    className="btn"
                                                    style={{
                                                        width: '100%',
                                                        padding: '12px',
                                                        borderRadius: '8px',
                                                        border: plan.highlight ? 'none' : `1px solid ${plan.themeColor}`,
                                                        backgroundColor: plan.highlight ? plan.themeColor : 'transparent',
                                                        color: plan.highlight ? '#FFFFFF' : plan.themeColor,
                                                        fontWeight: 600,
                                                        textTransform: 'none',
                                                        transition: 'all 0.3s ease',
                                                        display: 'block'
                                                    }}
                                                >
                                                    {plan.ctaName}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* PRICING COMPARE */}
                    <div className="pricing-compare pc-40 mt-80">
                        <div className="row">
                            <div className="col">
                                <h3 className="h3-sm text-center">Compare Pricing Packages</h3>
                                <div className="table-responsive">
                                    <table className="table text-center">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "34%" }} />
                                                <th style={{ width: "22%" }}>Essential</th>
                                                <th style={{ width: "22%" }}>Growth</th>
                                                <th style={{ width: "22%" }}>Scale</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* CORE FEATURES */}
                                            <tr>
                                                <th scope="row" className="text-start" style={{ color: '#1B1B1B', fontWeight: 600 }}>Core Features</th>
                                                <td />
                                                <td />
                                                <td />
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Active Projects</th>
                                                <td>20</td>
                                                <td>200</td>
                                                <td>Unlimited</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Monthly Characters</th>
                                                <td>100,000</td>
                                                <td>1,000,000</td>
                                                <td>Unlimited</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">File Management</th>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">App Integrations</th>
                                                <td>1 Integration</td>
                                                <td>5 Integrations</td>
                                                <td>Unlimited</td>
                                            </tr>

                                            {/* AI & AUTOMATION */}
                                            <tr>
                                                <th scope="row" className="text-start" style={{ color: '#1B1B1B', fontWeight: 600, paddingTop: '40px' }}>AI & Automation</th>
                                                <td />
                                                <td />
                                                <td />
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Pre-Translation (Automation)</th>
                                                <td className="ico-10 disabled-option"><span className="flaticon-cancel" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Custom MT Service Selection</th>
                                                <td className="ico-10 disabled-option"><span className="flaticon-cancel" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Custom Glossary</th>
                                                <td className="ico-10 disabled-option"><span className="flaticon-cancel" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Translation Memory (Centralized)</th>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>

                                            {/* COLLABORATION */}
                                            <tr>
                                                <th scope="row" className="text-start" style={{ color: '#1B1B1B', fontWeight: 600, paddingTop: '40px' }}>Collaboration</th>
                                                <td />
                                                <td />
                                                <td />
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Team Members</th>
                                                <td>Up to 2</td>
                                                <td>Up to 10</td>
                                                <td>Unlimited</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Shared Projects</th>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Role-based Access Control</th>
                                                <td className="ico-10 disabled-option"><span className="flaticon-cancel" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>

                                            {/* SUPPORT */}
                                            <tr>
                                                <th scope="row" className="text-start" style={{ color: '#1B1B1B', fontWeight: 600, paddingTop: '40px' }}>Support</th>
                                                <td />
                                                <td />
                                                <td />
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Support Level</th>
                                                <td>Email Support</td>
                                                <td>Priority Support</td>
                                                <td>Dedicated Support</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="text-start">Onboarding & Training</th>
                                                <td className="ico-10 disabled-option"><span className="flaticon-cancel" /></td>
                                                <td className="ico-10 disabled-option"><span className="flaticon-cancel" /></td>
                                                <td className="ico-15 green-color"><span className="flaticon-check" /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* PRICING NOTICE TEXT */}
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pricing-notice text-center mb-40">
                                <p className="p-md">
                                    The above prices do not include applicable taxes based on your
                                    billing address. The final price will be displayed on the
                                    checkout page, before the payment is completed
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* CALL TO ACTION-4 */}
            <section id="cta-4" className="cta-section division">
                <div className="cta-4-holder bg-snow">
                    <div className="container">
                        <div className="bg-white cta-4-wrapper">
                            <div className="row d-flex align-items-center">
                                <div className="col-lg-7 col-lg-8">
                                    <div className="cta-4-txt">
                                        <h4 className="h4-xl">Try Rush Studio free for 14 days. Start your trial now and pick a plan later</h4>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="text-end">
                                        <div className="cta-4-btn text-center">
                                            <Link to="/register" className="btn btn-skyblue tra-grey-hover">Get Started Now</Link>
                                            <p><Link to="/faqs">Read The FAQs</Link></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQs-2 */}
            <section id="faqs-2" className="wide-60 faqs-section division">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-8">
                            <div className="section-title title-01 mb-80">
                                <h2 className="h2-md">Got Questions? Look Here</h2>
                                <p className="p-xl">Find answers to common questions about our plans and services.</p>
                            </div>
                        </div>
                    </div>
                    <div className="faqs-2-questions">
                        <div className="row row-cols-1 row-cols-lg-2">
                            <div className="col">
                                <div className="questions-holder pr-15">
                                    <div className="question wow fadeInUp">
                                        <h5 className="h5-sm">Can I see Rush Studio in action before purchasing?</h5>
                                        <p className="p-lg">Yes! You can sign up for a 14-day free trial on any our plans to explore the platform features with no credit card required.</p>
                                    </div>
                                    <div className="question wow fadeInUp">
                                        <h5 className="h5-sm">What are the requirements for using Rush Studio?</h5>
                                        <p className="p-lg">Rush Studio is a cloud-based platform. All you need is a modern web browser and an internet connection.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="questions-holder pl-15">
                                    <div className="question wow fadeInUp">
                                        <h5 className="h5-sm">Do you have a free trial?</h5>
                                        <p className="p-lg">Absolutely. We offer a 14-day full-featured trial so you can experience everything Rush Studio has to offer before committing.</p>
                                    </div>
                                    <div className="question wow fadeInUp">
                                        <h5 className="h5-sm">How does Rush Studio handle my privacy?</h5>
                                        <p className="p-lg">We take data security seriously. Your translations and data are encrypted and we never use your data to train public AI models.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="more-questions">
                                <h5 className="h5-sm">Have more questions? <Link to="/contact">Ask your question here</Link></h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default PricingPage;
